import { countValue, roundCount, stringRounds, textValue } from "./upcomingMatch";
import { relayKey } from "./bullseyeRelaySheet";

function possiblePoints(stages) {
  if (roundCount(stages) === null) return null;
  const strings = stages.flatMap(stage => stage.strings);
  if (strings.some(string => countValue(string.maxRingScore) === null)) return null;
  return strings.reduce((total, string) => total + stringRounds(string) * Number(string.maxRingScore), 0);
}

function firearmTitle(group) {
  const title = textValue(group.title);
  return ({ rimfire: ".22 Rimfire", centerfire: "Centerfire", ".45": ".45 Caliber" })[title.toLowerCase()]
    || title || "Firearm group";
}

export function bullseyeOverview(match, groups = []) {
  const template = textValue(match.selectedCourseTemplateName);
  const title = /^\d+$/.test(template) ? `Precision Pistol ${template}` : template || "Precision Pistol";
  const firearms = groups.map(group => {
    const stages = Array.isArray(group.stages) ? group.stages : [];
    return {
      id: group.gunGroupId,
      title: firearmTitle(group),
      shots: roundCount(stages),
      points: possiblePoints(stages),
      // The three NMC stages are one course in the competitor's program.
      courses: [...new Set(stages.map(stage => textValue(stage.courseGroupName) || textValue(stage.name)).filter(Boolean))],
    };
  });
  const total = field => firearms.length && firearms.every(group => group[field] !== null)
    ? firearms.reduce((sum, group) => sum + group[field], 0) : null;
  const commonCourses = firearms.length && firearms[0].courses.length
    && firearms.every(group => JSON.stringify(group.courses) === JSON.stringify(firearms[0].courses))
    ? firearms[0].courses : [];
  return { title, firearms, shots: total("shots"), points: total("points"), commonCourses };
}

export function bullseyeRelayCount(competitors = [], plans = []) {
  const labels = [
    ...plans.map(plan => textValue(plan.label)),
    ...competitors.flatMap(person => (person.assignments || []).map(assignment => textValue(assignment.relayLabel))),
  ].map(relayKey).filter(Boolean);
  return new Set(labels).size;
}
